import { useNavigate } from 'react-router-dom';
import cn from 'classnames';
import { Checkbox } from 'components/Checkbox';
import styles from 'pages/Database/Coaches/CoachCard/CoachCard.scss';

export const CoachCard = ({ coach: { id, surname, name, debt }, isSelected, isSelectionMode, toggleSelection }) => {
  const navigate = useNavigate();

  const navigateToCoachPage = () => {
    navigate(`${id}`);
  };

  return (
    <button
      className={cn(styles.cardContainer, { [styles.selected]: isSelected })}
      onClick={() => (isSelectionMode ? toggleSelection(id) : navigateToCoachPage())}
    >
      {isSelectionMode && <Checkbox className={styles.checkbox} checked={isSelected} />}
      <div className={styles.card}>
        <div className={styles.info}>
          {isSelectionMode && <Checkbox className={styles.checkbox} checked={isSelected} />}
          <div className={styles.name}>
            {surname}
            <br />
            <strong>{name}</strong>
          </div>
        </div>
      </div>
      <div className={styles.plates}>{!!debt && <div className={styles.plate}>{debt}₴</div>}</div>
    </button>
  );
};
